/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_No_Tools_DescriptionInputs */



/**
* | output |
* | --- |
* | "This connector exposes no tools to configure yet. You can still add a subject and name a tool by hand." |
*
* @param {Rights_Tools_No_Tools_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_no_tools_description = /** @type {((inputs?: Rights_Tools_No_Tools_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_No_Tools_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Connector stellt noch keine konfigurierbaren Tools bereit. Sie können dennoch einen Betreff hinzufügen und einen Tool-Namen manuell angeben.")
	return /** @type {LocalizedString} */ ("This connector exposes no tools to configure yet. You can still add a subject and name a tool by hand.")
});